module.exports = __webpack_public_path__ + "media/dashboard/assets/images/video-off-blue-5f484ab8634a9666b35a2a9bf1e4318c.png";